import friday from './friday';
export interface BaseTracker {
  code: string;
  name?: string;
  data?: object;
}

/**
 * 埋点上报
 */
const report = (tracker: BaseTracker) => {
  friday?.pushData(tracker);
};

const reporteWebMenuView = (operation: string) => {
  report({
    code: 'web_bottom_menu_view',
    name: '菜单栏访问情况',
    data: { page_name: operation }
  });
};

const reporteSchOperation = (operation: string) => {
  report({
    code: 'web_meetingSchedule_operation',
    name: '会议日程页面操作',
    data: { meetingSchedule_operation: operation }
  });
};

const reporteContactOperation = (operation: string) => {
  report({
    code: 'web_contacts_operation',
    name: '通讯录页面操作',
    data: { contacts_operation: operation }
  });
};

const reporteMeetingRoom = (operation: string) => {
  report({
    code: 'web_meetingRoom_operation',
    name: '会议室页面操作',
    data: { meetingRoom_operation: operation }
  });
};

const reporteRecordStatus = (id: string, status: string) => {
  report({
    code: 'web_approval_record_status_view',
    name: '查看会议审批',
    data: { meeting_id: id, approval_record_status: status }
  });
};

const reporteMeetingConfig = (params: any) => {
  const file = params?.meetingFolderViews && params?.meetingFolderViews?.length > 0 ? 'YES' : 'NO';
  const agenda = !params?.content ? 'NO' : 'YES';
  const password = !params?.meetingAllocationViews?.password ? 'NO' : 'YES';
  const reason = !params?.reason ? 'NO' : 'YES';
  const data = {
    meeting_id: params?.meetingNo || '',
    meeting_topic: params?.subject || '', // 会议主题
    meeting_format: params?.isRepeatMeeting ? '周期会议' : '预约会议', // 会议形式
    meeting_location: params?.address || '', // 会议地点
    meeting_member: params?.members?.length || 0, // 会议人数
    meeting_type: (params?.meetingAllocationViews?.meetingTypes || []).join(','), // 会议类型  上报会议类型的枚举项，不选择时可以为空
    meeting_reminder: (params?.noticeLabels || [])?.join(','), // 会议提醒 上报提醒的枚举项；需要上报多个值时，则用,号间隔
    meeting_password: password, // 是否设置会议密码 YES/NO
    meeting_agenda: agenda, // 是否填写会议议程 YES/NO
    meeting_file: file, // 是否上传会议文件 YES/NO
    meeting_approval_reason: reason // 是否填写会议申请理由 YES/NO
  };
  console.log('--params-->', data);
  report({
    code: 'web_create_meetingReservation_setting',
    name: '创建会议预约配置',
    data
  });
};

const reporteMeetingSetting = (id: string, modify: string) => {
  report({
    code: 'web_modifyMeeting_setting',
    name: '修改会议预约配置',
    data: {
      meeting_id: id,
      meeting_modify: modify
    }
  });
};

const trackers = {
  reporteWebMenuView,
  reporteSchOperation,
  reporteContactOperation,
  reporteMeetingRoom,
  reporteRecordStatus,
  reporteMeetingConfig,
  reporteMeetingSetting
};

export default trackers;
